// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from '../../../components/iconify';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon('ic_user'),
  analytics: icon('ic_analytics'),
  dashboard: <Iconify icon="carbon:dashboard" />,
  setting: <Iconify icon="mdi:cog" />,
  ai: <Iconify icon="mingcute:ai-fill" />,
  aichat: <Iconify icon="si:ai-chat-duotone" />,
  graph: <Iconify icon="mdi:graph-bar" />,
  graph2: <Iconify icon="ic:baseline-auto-graph" />,
  map: <Iconify icon="mdi:map-marker-radius" />,
  forecast: <Iconify icon="mdi:chart-timeline-variant-shimmer" />,
  company: <Iconify icon="mdi:office-building" />,
  upload: <Iconify icon="mdi:database-import" />,
};

// ----------------------------------------------------------------------
// Roles: 1 = admin, 2 = organizer, 3 = viewer, 4 = superadmin.
// The legacy event-impact module is retired and no longer surfaced here.
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Flat menu — order fixed by the Ministry.
// ----------------------------------------------------------------------

// The Ministry story: Dashboard → Workforce → Demand & Supply Gap → Prediction
const DASHBOARD_ITEMS = [
  {
    title: 'Dashboard',
    path: PATH_DASHBOARD.general.talentIntelligence,
    icon: ICONS.dashboard,
  },
  {
    title: 'Workforce Analytics',
    path: PATH_DASHBOARD.general.talentAnalytics,
    icon: ICONS.graph,
  },
  {
    title: 'Demand vs Supply Gap',
    path: PATH_DASHBOARD.general.skillsGap,
    icon: ICONS.graph2,
  },
  {
    title: 'Sector Deep-Dive',
    path: PATH_DASHBOARD.general.talentSector,
    icon: ICONS.map,
  },
  {
    title: 'Prediction',
    path: PATH_DASHBOARD.general.prediction,
    icon: ICONS.ai,
  },
];

const AI_SETS_ITEM = {
  title: 'AI SETS',
  path: PATH_DASHBOARD.general.meitdAiAssistant,
  icon: ICONS.aichat,
};

const navConfig = [
  {
    // superadmin
    role: 4,
    groups: [{ subheader: '', items: [...DASHBOARD_ITEMS, AI_SETS_ITEM] }],
  },
  {
    // admin
    role: 1,
    groups: [{ subheader: '', items: [...DASHBOARD_ITEMS, AI_SETS_ITEM] }],
  },
  {
    // organizer
    role: 2,
    groups: [{ subheader: '', items: [...DASHBOARD_ITEMS, AI_SETS_ITEM] }],
  },
  {
    // viewer — read-only dashboards
    role: 3,
    groups: [{ subheader: '', items: DASHBOARD_ITEMS }],
  },
];

// Falls back to the viewer menu for unknown roles so the sidebar is never empty.
export default function getNavConfig(roleId) {
  const matched = navConfig.find((entry) => entry.role === Number(roleId)) || navConfig.find((entry) => entry.role === 3);
  return matched.groups;
}
